import { MultiSelectionStateByComponentId } from 'components/multi-selection';

export const EMPTY_MULTI_SELECTION_STATE: MultiSelectionStateByComponentId = {
  items: {},
  selectedCount: 0,
};
